import type { CurrencyCode } from '@noths/polaris-dev-ts-types';
import type { SerializedError } from '@reduxjs/toolkit';

import type { Facet } from 'src/redux/productsQuery/types/Facet';
import type { SortOption } from 'src/redux/productsQuery/types/SortOption';
import type { Product } from './types/Product';

export interface RequestProductsMetadata {
  facetTitle: string;
  optionActive: boolean;
  optionTitle: string;
}
export enum TriggerName {
  CHANGE_FACETS = 'changeFacets',
  CHANGE_SORT = 'changeSort',
  LOAD_MORE_PRODUCTS = 'loadMoreProducts',
  LOAD_PREVIOUS_PRODUCTS = 'loadPreviousProducts',
}

export interface ProviderMetadata {
  filter: string;
}

// return format of adapter
export interface RequestProductsActionProductsPayload {
  currencyCode: CurrencyCode;
  errorCode?: string;
  errorMessage?: string;
  lastPageLoaded: number;
  perPage: number;
  products: Product[];
  productsReturnedCount: number;
  providerAttributionToken: string | null;
  providerMetadata: ProviderMetadata | null;
  term: string | null;
  totalPages: number;
  totalProducts: number;
}

// return format of requestProducts thunk; used in reducer
export interface RequestProductsActionPayload {
  facets?: Facet[];
  metadata?: RequestProductsMetadata;
  products?: RequestProductsActionProductsPayload;
  sortOptions?: SortOption[];
  triggerName?: TriggerName;
}

export interface ProductsState {
  currencyCode: CurrencyCode;
  deliveryZone?: string;
  error?: SerializedError | null;
  initialProductPage?: number;
  lastPageLoaded: number | null;
  pageLoading: number | null;
  pages: Record<number, Product[]>;
  productsReturnedCount: number;
  providerAttributionToken: string | null;
  providerMetadata: ProviderMetadata | null;
  showFewResultsMessage?: boolean;
  totalPages: number;
  totalProducts: number;
}
